export type WishlistItem = {
  sku: string
}

export function useWishlist() {
  const latest = useState<WishlistItem | null>('latest', () => null)
  const wishlist = useLocalStorage<WishlistItem[]>('wishlist', [], { initOnMounted: true })

  async function removeFromWishlist(sku: string) {
    const index = wishlist.value.findIndex(item => item.sku === sku)
    latest.value = { sku }

    wishlist.value.splice(index, 1)
  }

  async function addToWishlist(sku: string) {
    wishlist.value.push({ sku })
    latest.value = { sku }
  }

  const toggleWishlist = async (sku: string) => {
    if (wishlist.value.find(item => item.sku === sku)) {
      await removeFromWishlist(sku)
    }
    else {
      await addToWishlist(sku)
    }
  }

  const count = computed(() => wishlist.value.length)

  return {
    count,
    latest,
    toggleWishlist,
    wishlist,
  }
}
